import { Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";

import BlogCardImg from "../../assets/AI_Roundup_Nov_social_share.width-800.format-webp 2.png";
import React from "react";

export const BlogCard = (props) => {
	let type = props.type;
	let title = props.title;
	let image = props.image;
	let description = props.description;
	let style = props.sg;
	if (type === "Top") {
		return (
			<>
				<Card
					sx={{
						maxWidth: 500,
						border: "1px solid #bfc0c1",
						borderRadius: "1rem",
						margin: "0.5rem",
						...style,
					}}>
					<CardActionArea>
						<CardMedia
							component='img'
							height='140'
							image={image || BlogCard}
							alt='Blog Image'
						/>
						<CardContent>
							<Typography gutterBottom variant='h5' component='div'>
								{title ||
									"Title: Lorem ipsum dolor sit amet consectetur. Amet fringilla cursus lectus nullam non."}
							</Typography>
							<Typography variant='body2' sx={{ color: "text.secondary" }}>
								{description}
							</Typography>
						</CardContent>
					</CardActionArea>
				</Card>
			</>
		);
	} else {
		return (
			<>
				<Card
					sx={{
						maxWidth: 400,
						border: "1px solid #bfc0c1",
						borderRadius: "1rem",
						margin: "0.5rem",
						...style,
					}}>
					<CardActionArea>
						<CardContent>
							<Typography gutterBottom variant='h5' component='div'>
								{title}
							</Typography>
							<Typography variant='body2' sx={{ color: "text.secondary" }}>
								{description}
							</Typography>
						</CardContent>
						<CardMedia
							component='img'
							height='140'
							image={image || BlogCard}
							alt='Blog Image'
						/>
					</CardActionArea>
				</Card>
			</>
		);
	}
};
